import { Signals } from "@/Imports";
import WsWrapper from "./socket/ws-wrapper";
import WsClient from "./socket/ws-client";
import WsBaseRequest from "./socket/ws-request";
import Config from "@/config/Config";
import SyncTime from "@/managers/comunication/socket/sync-time";
import Facade from "@/Facade";
import URLParser from "@/managers/comunication/URLParser";
import Platform from "@base/utils/Platform";
// import PromoBackend from "@/managers/comunication/PromoBackend"
import GameStatesEnum from "@/states/GameStatesEnum";
import GameSignals from "../../signals/GameSignals";

export default class BackendManager {
  constructor() {
    // this.promo = new PromoBackend()
    this.URLParser = new URLParser();
    BackendManager.playerConnected = false;

    // Game listenter
    Signals.gameMessage.add(this.onGameMessage, this);
    GameSignals.playerConnect.add(this.setPlayerConnected);

    this.listener = {
      onopen: (event) => {
        console.log("onopen");
        Signals.socketOpened.dispatch();
      },

      onerror: (event) => {
        console.log("onerror");
      },

      onclose: (event) => {
        if (event.code === 1006 && !BackendManager.playerConnected) {
          this.handleError({
            msg: "Connection error",
            type: Config.POPUP_KEYS.CONNECTION_ERROR,
            code: event.code,
          });
          BackendManager.playerConnected = false;
          // window.location.reload()
          return;
        } else if (BackendManager.playerConnected) {
          this.handleError({
            msg: { b: "", c: 804, msg: "errorConnection" },
            type: Config.POPUP_KEYS.CONNECTION_ERROR,
            code: 804,
          });
          // window.location.reload()
          BackendManager.playerConnected = false;
          return;
        }

        this.wsWrapper.unsubscribeStatic("rs");
        this.wsWrapper.unsubscribeStatic("re");
        console.log("onclose");
        Signals.socketClosed.dispatch();
      },

      connectionInfo: ({ latency }) => {
        //console.log(latency)
      },
    };
  }
  setPlayerConnected() {
    BackendManager.playerConnected = true;
    console.log("SETTING PLAYER CONNECTED TO TRUE");
  }
  handleError({ msg, type, code }) {
    const error = { msg, type, code };
    Signals.errorMessage.dispatch(error);
  }

  onMessage(e) {
    console.log(e);
  }

  onGameMessage(data) {
    switch (data.message) {
      case "openSocket":
        this.wsClient = new WsClient(Config.HOST);
        this.wsWrapper = new WsWrapper(this.wsClient);
        this.wsWrapper.subscribeLifecycleListener(this.listener);
        Facade.syncTime = new SyncTime(this.wsWrapper);

        this.setupBalanceUpdate(this.wsWrapper);
        break;

      case "auth":
        this.sendAuth({
          p: this.URLParser.player_uid,
          c: this.URLParser.currency,
          mob: Platform.isMobile(),
          l: this.URLParser.language,
          ext: JSON.stringify(this.URLParser.ext_params),
        });
        break;

      case "bet":
        let amount = data.amount;

        const o = {
          a: amount,
          ac: data.autoCollect,
          t: "bet",
          c: data.cell,
        };
        this.sendBet(o);
        console.log("BET: ----> ", o);
        break;

      case "collect":
        this.sendCollect({
          c: data.cell,
        });
        break;

      case "cancel":
        this.sendCancel({
          c: data.cell,
        });
        break;

      case "multipliers":
        this.sendMultipliers({});
        break;

      case "updateBalance":
        this.sendBalance({});
        break;
    }
  }

  async sendAuth(data) {
    let r = await this.auth(data);
    console.log("AUTH:", r);

    if (r.err) {
      console.log(r.err.msg);
      let f = Config.POPUP_TYPES;
      this.handleError({
        msg: r.err,
        type: Config.POPUP_KEYS.CONNECTION_ERROR,
        code: r.err.code,
      });
      return;
    }
    GameSignals.playerConnect.dispatch();
    Signals.initGame.dispatch(r.d);

    await Facade.syncTime.syncTime();
    this.wsWrapper.subscribeStatic("rs", this.onRoundStart.bind(this));
    this.wsWrapper.subscribeStatic("re", this.onRoundEnd.bind(this));
    this.wsWrapper.subscribeStatic("ac", this.onAutoCollect.bind(this));
    this.wsWrapper.subscribeStatic("bts", this.onBets.bind(this));
    this.wsWrapper.subscribeStatic("gi", this.onGameInfo.bind(this));

    console.log("GETTING STATE...");
    let r1 = await this.state({});
    console.log("STATE:", r1);

    Facade.model.bonuses = r1.d.s.bns;

    const multipliers = await this.multipliers({});
    Facade.model.multipliersHistory = multipliers;

    if (Facade.model.lastUpdateTime > r1.d.s.u) {
      return;
    }
    Facade.model.lastUpdateTime = r1.d.s.u;
    Facade.model.startTime = r1.d.s.s;

    if (r1.d.s.ie == true) {
      Facade.model.totalTimeToMakeBets = r1.d.s.d / 1000;
      const startDelay =
        Math.max(0, r1.d.s.u + r1.d.s.d - Facade.syncTime.time) / 1000;
      Facade.model.makeBetsTime = startDelay;
      console.log("THE ROUND WILL START IN:", startDelay);

      Facade.initialState = GameStatesEnum.MAKE_BETS;
      Signals.forceMakeBets.dispatch();
      //make bets
      return;
    }

    Facade.model.deltaTime = (Facade.syncTime.time - r1.d.s.s) / 1000;
    Facade.model.makeBetsTime = 0;

    if (Facade.model.deltaTime > 0) {
      console.log("the plane is flying", Facade.model.deltaTime, "sec");

      Facade.initialState = GameStatesEnum.ROUND_START;
      Signals.forceRoundStart.dispatch();
    } else {
      Facade.model.makeBetsTime = Math.abs(Facade.model.deltaTime);
      console.log(
        "the plane is starting flying right now in",
        Math.abs(Facade.model.deltaTime)
      );
      Facade.model.deltaTime = 0;
      setTimeout(() => {
        Facade.initialState = GameStatesEnum.ROUND_START;
        Signals.forceRoundStart.dispatch();
      }, Facade.model.makeBetsTime * 1000);
    }
  }

  async sendJackpot(data) {
    let r = await this.jackpot(data);
    console.log(r);
  }

  async sendBet(data) {
    let r = await this.bet(data);
    if (r.err) {
      let type = Config.POPUP_KEYS.BET_ERROR;
      if (r.err.c == 401 || r.err.c == 804) {
        type = Config.POPUP_KEYS.CONNECTION_ERROR;
      }
      this.handleError({ msg: r.err, type: type, code: r.err.code });
      console.log(r.err.msg);
      return;
    }

    if (r.d.r) {
      Facade.model.balance = r.d.b;
    }
    Facade.model.freebets = r.d.fb;
    Facade.model.playersState = r.d.ps;
    console.log(r);
  }

  async sendCollect(data) {
    let r = await this.collect(data);
    if (r.err) {
      this.handleError({
        msg: r.err,
        type: Config.POPUP_KEYS.CONNECTION_ERROR,
        code: r.err.code,
      });
      console.log(r.err.msg);
      return;
    }
    if (r.d.r) {
      Facade.model.balance = r.d.b;
    }
    Facade.model.freebets = r.d.fb;
    Facade.model.collect(r);
    console.log(r);
  }

  async sendCancel(data) {
    let r = await this.cancel(data);
    if (r.err) {
      this.handleError({
        msg: r.err,
        type: Config.POPUP_KEYS.CONNECTION_ERROR,
        code: r.err.code,
      });
      console.log(r.err.msg);
      return;
    }
    Facade.model.cancel(r.d.ps);
    if (r.d.r) {
      Facade.model.balance = r.d.b;
    }
    console.log(r);
  }

  async sendMultipliers(data) {
    let r = await this.multipliers(data);
    console.log(r);
  }

  async sendAutocollect(data) {
    let r = await this.autocollect(data);
    console.log(r);
  }

  onRoundStart(data) {
    console.log("<SERVER MESSAGE>: round start");
    if (Facade.model.lastUpdateTime > data.d.s.u) {
      return;
    }
    Facade.model.deltaTime = 0;
    Facade.model.startTime = data.d.s;

    Facade.model.roundStartDelay = Math.max(0, data.d.s - Facade.syncTime.time);

    Facade.model.bonuses = data.d.bns;
    Facade.model.roundStartTime = data.d.u;
    Facade.model.lastUpdateRoundStart = data.d.u;
    Facade.model.lastUpdateTime = data.d.u;

    Facade.initialState = GameStatesEnum.ROUND_START;
    Signals.forceRoundStart.dispatch();
  }

  onRoundEnd(data) {
    console.log("<SERVER MESSAGE>: round end", data);
    if (Facade.model.lastUpdateTime >= data.d.u) {
      return;
    }
    Facade.model.finalMultiplier = data.d.m;
    console.log("this.finalMultiplier:", Facade.model.finalMultiplier);
    Facade.model.deltaTime = 0;
    Facade.model.totalTimeToMakeBets = data.d.d / 1000;
    Facade.model.makeBetsTime = data.d.d / 1000;
    Facade.model.lastUpdateTime = data.d.u;
    Facade.model.roundStartTime = data.d.rst;
    //console.log('MULTIPLIER FROM SERVER: ', data.d.m)

    Facade.initialState = GameStatesEnum.ROUND_END;
    Signals.forceRoundEnd.dispatch();
  }

  onAutoCollect(data) {
    console.log("<SERVER MESSAGE>: auto collect");
    if (Facade.model.lastUpdateTime > data.d.u) {
      return;
    }

    if (data.err) {
      console.log(data.err.msg);
      return;
    }
    Facade.model.freebets = data.d.fb;
    Facade.model.balance = data.d.b;
    Facade.model.collect(data);

    Signals.autoCollectHappened.dispatch(data);
  }

  onBets(data) {
    console.log("<SERVER MESSAGE>: Bets");
    if (Facade.model.lastUpdateTime > data.d.u) {
      return;
    }

    if (data.err) {
      console.log(data.err.msg);
      return;
    }

    Facade.model.bets(data.d);
  }

  onGameInfo(data) {
    console.log("<SERVER MESSAGE>: GameInfo");

    Facade.model.bonusApplied(data.d);
  }

  async auth(data) {
    return this.asyncSendMessage(new WsBaseRequest("auth", data));
  }

  async jackpot(data) {
    return this.asyncSendMessage(new WsBaseRequest("jackpot", data));
  }

  async bet(data) {
    return this.asyncSendMessage(new WsBaseRequest("bet", data));
  }

  async collect(data) {
    return this.asyncSendMessage(new WsBaseRequest("collect", data));
  }

  async cancel(data) {
    return this.asyncSendMessage(new WsBaseRequest("cancel", data));
  }

  async multipliers(data) {
    return this.asyncSendMessage(new WsBaseRequest("multipliers", data));
  }

  async autocollect(data) {
    return this.asyncSendMessage(new WsBaseRequest("autocollect", data));
  }

  async state(data) {
    return this.asyncSendMessage(new WsBaseRequest("state", data));
  }

  async asyncSendMessage(request, timeout) {
    return new Promise((resolve, reject) => {
      this.wsWrapper?.sendMessage(
        request,
        function (resp) {
          resolve(resp);
        },
        timeout
      );
    });
  }

  // region #Balance timout
  /**
   * This is nearly mixin, that invoke setup updating of the balance through websocket 'balance' method
   * You should add it only once in the wsWrapper initialization and forget about it
   * @param wsWrapper
   */
  setupBalanceUpdate(wsWrapper) {
    this.balanceTimeoutID = null;

    const BALANCE_UPDATE_TIMEOUT = 60000;

    this.balance = async (data) => {
      return this.asyncSendMessage(new WsBaseRequest("balance", data));
    };

    this.sendBalance = async () => {
      const data = {
        r: 1,
        m: "balance",
        d: {},
      };

      const r = await this.balance(data);
      if (r.re) {
        Facade.model.balance = r.d.b;
      }
    };

    this.cancelBalanceTimeout = () => {
      if (this.balanceTimeoutID) {
        clearTimeout(this.balanceTimeoutID);
        this.balanceTimeoutID = null;
      }
    };

    this.setBalanceTimeout = () => {
      this.cancelBalanceTimeout();
      this.balanceTimeoutID = setTimeout(async () => {
        this.sendBalance();
      }, BALANCE_UPDATE_TIMEOUT);
    };

    Signals.balanceUpdate.add(this.setBalanceTimeout, this);
    wsWrapper.subscribeLifecycleListener({
      onopen: () => this.setBalanceTimeout(),
      onerror: () => this.cancelBalanceTimeout(),
      onclose: () => this.cancelBalanceTimeout(),
    });
  }

  // endregion
}
